(function () {
	const header = () => {
		$("[data-hover-opacity]").hover(
			function () {
				if (
					$(this).hasClass("header__follow") &&
					$(".header-details__search").attr("open")
				) {
					return "";
				}
				const id = String($(this).data("hover-opacity")).replace(/(["\\])/g, "\\$1");
				$(`[data-hover-opacity="${id}"]`).addClass("opacity");
				$(this).removeClass("opacity");
			},
			function () {
				const id = String($(this).data("hover-opacity")).replace(/(["\\])/g, "\\$1");
				$(`[data-hover-opacity="${id}"]`).removeClass("opacity");
			}
		);

		const headerOverlay = document.querySelector(".header__overlay");
		const searchDetails = document.querySelector(".header__search details");
		headerOverlay.addEventListener("click", () => {
			searchDetails.removeAttribute("open");
			document.body.classList.remove("overflow-hidden-search");
		});
	};

	/*
	 * Keep every desktop dropdown inside the viewport.
	 *
	 * The dropdowns share one width (see --header-submenu-chars) and are
	 * left-anchored to their menu item, so the right-most ones can extend past
	 * the right edge of the screen. They are hidden with opacity, not
	 * display: none, so they stay in layout and add horizontal overflow even
	 * while closed — which shows up as phantom margin on the right of the page.
	 *
	 * This measures each one and, only when it would overflow, nudges it left by
	 * exactly the overflow amount. Left-alignment is preserved for every
	 * dropdown that already fits; it is broken only where it has to be.
	 * margin-left is used rather than transform because the CSS already applies
	 * translateX(1.2rem) here and we don't want to fight it.
	 *
	 * Danny Lim (Sleek App).
	 */
	const clampSubmenus = () => {
		const nav = document.querySelector(".header__inline-menu_bottom");
		if (!nav) return;

		// Top-level dropdowns only. Nested ones are anchored at left: 100% of
		// their parent and would need separate handling if a third level is added.
		const menus = nav.querySelectorAll(":scope > ul > li > .header__submenu");
		const GUTTER = 16;

		menus.forEach((menu) => {
			// Reset first so each pass measures from the CSS-defined position
			// rather than compounding a previous nudge.
			menu.style.marginLeft = "";

			if (window.innerWidth < 1200) return;

			const rect = menu.getBoundingClientRect();
			// clientWidth excludes the scrollbar, unlike window.innerWidth.
			const overflow = rect.right - (document.documentElement.clientWidth - GUTTER);
			if (overflow <= 0) return;

			// Never push the left edge off-screen while fixing the right edge.
			const shift = Math.min(overflow, Math.max(0, rect.left - GUTTER));
			if (shift > 0) menu.style.marginLeft = `-${shift}px`;
		});
	};

	let clampTimer;
	const scheduleClamp = () => {
		clearTimeout(clampTimer);
		clampTimer = setTimeout(clampSubmenus, 100);
	};

	window.addEventListener("resize", scheduleClamp);
	// Widths are in ch units, so they shift once the webfont swaps in.
	window.addEventListener("load", clampSubmenus);
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(clampSubmenus);
	}

	document.addEventListener("shopify:section:load", () => {
		header();
		clampSubmenus();
	});

	header();
	clampSubmenus();
})();
